import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id DFC9E65E-7019-4520-9797-418E410FEABC
 * name folder-open-outline
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/folder-open-outline.svg
 * tags
 * - Files / Folders 
 */
export const FolderOpenOutlineIcon = createSvgIcon(<><path d="M6.1,10L4,18V8H21A2,2 0 0,0 19,6H12L10,4H4A2,2 0 0,0 2,6V18A2,2 0 0,0 4,20H19C19.9,20 20.7,19.4 20.9,18.5L23.2,10H6.1M19,18H6L7.6,12H20.6L19,18Z" /></>, 'FolderOpenOutlineIcon');
export default FolderOpenOutlineIcon